export default {"src":"/_next/static/media/spf-text-logo.b534d081.svg","height":120,"width":700};